jQuery(document).ready(function ($) {
    'use strict';

    var HH = window.HH || {};

    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined'
        || typeof HH.revelerEnLignes !== 'function') {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    // .bloc_blog est un autre bloc, sans accroche rose
    var blocs = document.querySelectorAll('.bloc_chapeau:not(.bloc_blog)');

    if (!blocs.length) {
        return;
    }

    var LIGNES = {duree: 0.7, decalage: 0.09};

    var DECLENCHEMENT = 'top 80%';

    Array.prototype.forEach.call(blocs, function (bloc) {
        var accroche = bloc.querySelector('.texte_en_avant');

        if (!accroche) {
            return;
        }

        gsap.set(accroche, {opacity: 0});

        // sans policesPretes, SplitText coupe sur la police de substitution
        HH.policesPretes().then(function () {
            var tl = gsap.timeline({
                scrollTrigger: {
                    trigger: bloc,
                    start: DECLENCHEMENT,
                    once: true
                }
            });

            HH.revelerEnLignes(tl, accroche, 0, LIGNES);
        });
    });
});
